import { PageBase } from 'frontend/common-imports'
import conversionSet from 'frontend/lib/conversion/conversion-set'

export default class RoomPage extends PageBase {
  static handleDOMReady () {
    super.handleDOMReady()
    conversionSet.push({
      type: 'event', event: 'view_item', currency: 'USD', value: 1, items: [{ item_id: this.props.roomFriendlyId }],
    })
  }

  static get scheduleRoot () {
    return document.getElementById('room_schedule_react')
  }
}
